<template>
  <div class="interactiveMap">
    <gmap-map
      :center="{ lat: 19.22096, lng: -97.75305 }"
      :zoom="17"
      style="width: 100%; height: 500px"
    >
      <gmap-polygon :options="{ strokeColor: '#009900', fillColor: '#009900' }" :paths="paths"></gmap-polygon>
      <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen = false"
      ></gmap-info-window>

      <gmap-marker
        :key="i"
        v-for="(m, i) in markers"
        :position="m.position"
        :clickable="true"
        @click="toggleInfoWindow(m, i)"
      ></gmap-marker>
    </gmap-map>
    <div class="table mt-3">
      <div class="headers">
        <div class="title-left">
          <h1>{{ $t("interactiveMap.table.preview") }}</h1>
          <p>{{ $t("interactiveMap.table.headText") }}</p>
        </div>
        <div class="item-right">
          <h4>
            {{ $t("interactiveMap.table.showing") }} 1-{{ this.points.length }}
            {{ $t("interactiveMap.table.of") }} {{ totalPoints }}
          </h4>
          <button
            v-if="this.points.length === 10 && +totalPoints !== 10"
            @click="publishAndNext"
            class="btn btn-publish"
          >{{ $t("interactiveMap.table.publishBtn") }}</button>
          <button
            v-if="this.points.length <= 10 && +totalPoints <= 10"
            @click="publishAndNext"
            class="btn btn-publish"
          >{{ $t("surveys.modal.publish") }}</button>
        </div>
      </div>
      <v-server-table
        :columns="table_options.columns"
        :options="table_options.options"
        ref="userTable"
      >
        <template v-slot:actions="props">
          <div class="actions">
            <!-- Edit -->

            <i class="far fa-edit" @click="openModal(props.row)"></i>
          </div>
        </template>
      </v-server-table>
      <!-- Modal -->
      <Modal v-if="modalActive" @closeModal="closeModal">
        <div class="right-controls">
          <span @click="closeModal">Cancelar</span>
          <button class="btn btn-publish" @click="updatePoint">Actualizar</button>
        </div>
        <div class="body-modal">
          <div class="left">
            <gmap-map
              :center="{ lat: centerLat, lng: centerLong }"
              :zoom="17"
              style="width: 100%; height: 750px"
            >
              <gmap-polygon
                :options="{ strokeColor: '#009900', fillColor: '#009900' }"
                :paths="singlePath"
                :editable="true"
                @paths_changed="updateEdited($event)"
              ></gmap-polygon>
              <gmap-marker
                :key="i"
                v-for="(m, i) in singleMarker"
                :draggable="true"
                :position="m.position"
                @drag="updateCoordinates"
              ></gmap-marker>
            </gmap-map>
          </div>
          <div class="right">
            <p>{{ $t("interactiveMap.alertText") }}</p>
            <div class="row">
              <div class="col-md-6 mb-4">
                <label>
                  {{
                  $t("interactiveMap.table.headings.polygonName")
                  }}
                </label>
                <input
                  type="text"
                  v-model="polygonName"
                  :placeholder="$t('interactiveMap.table.headings.polygonName')"
                />
              </div>
              <div class="col-md-6 mb-4">
                <label>
                  {{
                  $t("interactiveMap.table.headings.addressEs")
                  }}
                </label>
                <input
                  class="mb-2"
                  type="text"
                  :placeholder="$t('interactiveMap.table.headings.addressEs')"
                  v-model="addressEs"
                />
                <input
                  v-model="addressEn"
                  type="text"
                  :placeholder="$t('interactiveMap.table.headings.addressEn')"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label>
                  {{
                  $t("interactiveMap.table.headings.category")
                  }}
                </label>
                <!-- <v-select
                  inputId="select-search-input"
                  :placeholder="$t('interactiveMap.table.headings.category')"
                  :options="selectOptions"
                  v-model="category"
                ></v-select>-->
                <select name id v-model="category.value">
                  <option
                    v-for="(options, index) in selectOptions"
                    :value="options.value"
                    :key="index"
                  >{{ options.label }}</option>
                </select>
              </div>
              <div class="col-md-6">
                <label>{{ $t("interactiveMap.table.headings.floor") }}</label>
                <input
                  class="mt-1"
                  type="number"
                  :placeholder="$t('interactiveMap.table.headings.floor')"
                  v-model="floor"
                />
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-6">
                <label>{{ $t("interactiveMap.table.headings.nameEs") }}</label>
                <input
                  type="text"
                  v-model="nameEs"
                  :placeholder="$t('interactiveMap.table.headings.nameEs')"
                />
                <input
                  class="mt-2"
                  type="text"
                  v-model="nameEn"
                  :placeholder="$t('interactiveMap.table.headings.nameEn')"
                />
              </div>
              <div class="col-md-6">
                <label>{{ $t("interactiveMap.table.mainCoordinate") }}</label>
                <div class="puntos">
                  <div class="inputs-puntos">
                    <input
                      v-model="mainLat"
                      type="text"
                      :placeholder="$t('interactiveMap.table.latitude')"
                    />
                    <input
                      class="ml-2"
                      type="text"
                      :placeholder="$t('interactiveMap.table.longitude')"
                      v-model="mainLong"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-6">
                <label>
                  {{
                  $t("interactiveMap.table.headings.shortDescriptionEs")
                  }}
                </label>
                <input
                  type="text"
                  v-model="shortDescriptionEs"
                  :placeholder="
                    $t('interactiveMap.table.headings.shortDescriptionEs')
                  "
                />
                <input
                  class="mt-2"
                  type="text"
                  v-model="shortDescriptionEn"
                  :placeholder="
                    $t('interactiveMap.table.headings.shortDescriptionEn')
                  "
                />

                <div class="long-desc mt-4">
                  <label>
                    {{
                    $t("interactiveMap.table.headings.descriptionEs")
                    }}
                  </label>
                  <textarea
                    :placeholder="
                      $t('interactiveMap.table.headings.descriptionEs')
                    "
                    cols="20"
                    rows="3"
                    v-model="descriptionEs"
                  ></textarea>
                  <textarea
                    class="mt-3"
                    :placeholder="
                      $t('interactiveMap.table.headings.descriptionEn')
                    "
                    cols="20"
                    rows="3"
                    v-model="descriptionEn"
                  ></textarea>
                </div>
              </div>
              <!-- Puntos dinamicos -->
              <div class="col-md-6" v-if="polygonCoordinates.length > 3">
                <label>{{ $t("interactiveMap.table.coordinates") }}</label>
                <div class="scrollable">
                  <div class="puntos" v-for="(point, index) in polygonCoordinates" :key="index">
                    <label>
                      {{ $t("interactiveMap.table.point") }}
                      {{ index + 1 }}
                    </label>
                    <div class="inputs-puntos">
                      <input
                        type="text"
                        :placeholder="$t('interactiveMap.table.latitude')"
                        v-model="polygonCoordinates[index].lat"
                      />
                      <input
                        class="ml-2"
                        type="text"
                        :placeholder="$t('interactiveMap.table.longitude')"
                        v-model="polygonCoordinates[index].long"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- fin de puntos dinamicos -->
              <div class="row mt-3">
                <div class="col-md-6">
                  <label>
                    {{
                    $t("interactiveMap.table.headings.schedule")
                    }}
                  </label>
                  <input
                    v-model="schedule"
                    type="text"
                    :placeholder="$t('interactiveMap.table.headings.schedule')"
                  />
                </div>
                <div class="col-md-6">
                  <label>
                    {{
                    $t("interactiveMap.table.headings.observations")
                    }}
                  </label>
                  <input
                    type="text"
                    v-model="observations"
                    :placeholder="
                      $t('interactiveMap.table.headings.observations')
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/interactiveMap.js";
const api = new API_SERVICE();
const Modal = () => import("@/components/Modal");
import Vue from "vue";
export default {
  components: {
    Modal
  },
  data() {
    return {
      edited: null,
      paths: [],
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      modalActive: false,
      infoOptions: {
        content: "",
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      columns: [
        "id",
        "polygonName",
        "floor",
        "nameEs",
        "nameEn",
        "coordinates",
        "mainCoordinates",
        "addressEs",
        "addressEn",
        "schedule",
        "shortDescriptionEs",
        "shortDescriptionEn",
        "descriptionEs",
        "descriptionEn",
        "observations",
        "actions"
      ],
      points: [],
      singleMarker: [],
      singlePath: [],
      centerLat: 19.22096,
      centerLong: -97.75305,
      polygonName: "",
      floor: 0,
      category: {
        label: "",
        value: 0
      },
      nameEs: "",
      nameEn: "",
      coordinates: "",
      addressEs: "",
      addressEn: "",
      schedule: "",
      shortDescriptionEs: "",
      shortDescriptionEn: "",
      descriptionEs: "",
      descriptionEn: "",
      observations: "",
      mainLat: 0,
      mainLong: 0,
      selectOptions: [],
      polygonCoordinates: [],
      singleId: 0,
      totalPoints: 0
    };
  },
  async beforeMount() {
    await this.getThePoints();
    await this.getTheCategorys();
  },
  methods: {
    updateCoordinates(location) {
      this.singleMarker[0] = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng()
      };
      // let parseLat =
      this.mainLat = location.latLng.lat().toFixed(5);
      this.mainLong = location.latLng.lng().toFixed(5);
    },

    openModal: function(polygon) {
      this.singleMarker = [];
      this.singlePath = [];
      this.modalActive = true;
      this.singleId = polygon.id;
      this.centerLat = polygon.latMain;
      this.centerLong = polygon.longMain;
      this.polygonName = polygon.polygonName;
      this.floor = polygon.floor;
      //Obtener la categoria
      let category = this.selectOptions.filter(
        item => item.value === polygon.category
      );
      this.category.value = category[0].value;
      this.category.label = category[0].label;
      this.polygonCoordinates = polygon.coordinates2.sort(
        (a, b) => a.lat - b.lat
      );
      this.nameEs = polygon.nameEs;
      this.nameEn = polygon.nameEn;
      this.addressEs = polygon.addressEs;
      this.addressEn = polygon.addressEn;
      this.schedule = polygon.schedule;
      this.shortDescriptionEs = polygon.shortDescriptionEs;
      this.shortDescriptionEn = polygon.shortDescriptionEn;
      this.descriptionEs = polygon.descriptionEs;
      this.descriptionEn = polygon.descriptionEn;
      this.observations = polygon.observations;
      this.mainLat = polygon.latMain;
      this.mainLong = polygon.longMain;
      let marker = {};
      let pol = [];
      if (polygon.coordinates2.length < 4) {
        marker = {
          position: {
            lat: polygon.latMain,
            lng: polygon.longMain
          }
        };
        this.singleMarker.push(marker);
      } else {
        pol = [];
        var bounds = new google.maps.LatLngBounds();
        for (
          let indexPolygon = 0;
          indexPolygon < polygon.coordinates2.length;
          indexPolygon++
        ) {
          pol.push(
            new google.maps.LatLng(
              polygon.coordinates2[indexPolygon].lat,
              parseFloat(polygon.coordinates2[indexPolygon].long)
            )
          );
          bounds.extend(
            new google.maps.LatLng(
              polygon.coordinates2[indexPolygon].lat,
              parseFloat(polygon.coordinates2[indexPolygon].long)
            )
          );
        }
        var center = bounds.getCenter();
        let newPoints = this.getNearestPoint(center, pol);
        let castNewPoints = [];
        for (let index2 = 0; index2 < newPoints.length; index2++) {
          castNewPoints.push({
            lat: newPoints[index2].lat(),
            lng: newPoints[index2].lng()
          });
        }
        this.singlePath.push(castNewPoints);
      }
    },
    async publishAndNext() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        let pointToUpdate = {};
        for (let index = 0; index < this.points.length; index++) {
          pointToUpdate = {
            lat: this.points[index].latMain,
            long: this.points[index].longMain,
            category: this.points[index].category,
            published: true
          };

          const resp = await api.editPoint(
            pointToUpdate,
            this.points[index].id
          );
        }
        if (this.points.length <= 10 && +this.totalPoints <= 10) {
          this.$router.push({ name: "Map Upload" });
          return;
        }
        await this.getThePoints();
        this.$refs.userTable.refresh();
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    updatePoint: async function() {
      this.polygonCoordinates = this.polygonCoordinates.sort(
        (a, b) => a.lat - b.lat
      );

      let params = {
        floor: +this.floor,
        polygonName: this.polygonName,
        nameEs: this.nameEs,
        nameEn: this.nameEn,
        lat: +this.mainLat,
        long: +this.mainLong,
        addressEs: this.addressEs,
        addressEn: this.addressEn,
        schedule: this.schedule,
        shortDescriptionEs: this.shortDescriptionEs,
        shortDescriptionEn: this.shortDescriptionEn,
        descriptionEs: this.descriptionEs,
        descriptionEn: this.descriptionEn,
        observations: this.observations,
        category: this.category.value,
        coordinates: this.polygonCoordinates,
        published: false
      };
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.editPoint(params, this.singleId);

        await this.getThePoints();
        this.$refs.userTable.refresh();
      } catch (error) {
        console.log(error);
      } finally {
        this.closeModal();
        this.$store.commit("global/SET_LOADING", false);
      }
    },

    closeModal: function() {
      this.modalActive = false;
    },
    updateEdited(mvcArray) {
      let paths = [];
      let paths2 = [];
      let initialPoints = this.polygonCoordinates.length;
      let initialSinglePath = this.lodash.cloneDeep(this.singlePath);
      for (let i = 0; i < mvcArray.getLength(); i++) {
        let path = [];
        let path2 = [];

        for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {
          let point = mvcArray.getAt(i).getAt(j);

          path.push({ lat: point.lat(), long: point.lng() });
          path2.push({ lat: point.lat(), lng: point.lng() });
        }
        paths.push(path);
        paths2.push(path2);
      }
      if (paths[0].length === initialPoints) {
        this.polygonCoordinates = paths[0];
        this.singlePath = paths2;
      } else {
        this.singlePath = initialSinglePath;
      }
    },

    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoOptions.content = marker.infoText;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    getThePoints: async function(page = 0) {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.getAllPoints(page);
        let cloneDeep = this.lodash.cloneDeep([]);
        this.points = resp.points.results;
        this.totalPoints = resp.points.total;
        //Rellenar los marks y ploygonos
        let marker = {};
        let polygon = [];
        this.markers = [];
        this.paths = [];

        for (let index = 0; index < this.points.length; index++) {
          if (this.points[index].coordinates.length < 4) {
            marker = {
              position: {
                lat: this.points[index].latMain,
                lng: this.points[index].longMain
              },
              infoText:
                "<strong>" + this.points[index].polygonName + "</strong>"
            };
            this.markers.push(marker);
          } else {
            polygon = [];
            var bounds = new google.maps.LatLngBounds();
            for (
              let indexPolygon = 0;
              indexPolygon < this.points[index].coordinates.length;
              indexPolygon++
            ) {
              polygon.push(
                new google.maps.LatLng(
                  this.points[index].coordinates[indexPolygon].lat,
                  parseFloat(this.points[index].coordinates[indexPolygon].long)
                )
              );
              bounds.extend(
                new google.maps.LatLng(
                  this.points[index].coordinates[indexPolygon].lat,
                  parseFloat(this.points[index].coordinates[indexPolygon].long)
                )
              );
            }
            var center = bounds.getCenter();
            let newPoints = this.getNearestPoint(center, polygon);
            // polygon = polygon.sort((a, b) => a.lat - b.lat);
            let castNewPoints = [];
            for (let index2 = 0; index2 < polygon.length; index2++) {
              castNewPoints.push({
                lat: polygon[index2].lat(),
                lng: polygon[index2].lng()
              });
            }
            this.paths.push(castNewPoints);
          }
        }
      } catch (error) {
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    getNearestPoint(centerPoint, points = []) {
      try {
        for (var i = 0; i < points.length; i++) {
          points[i].bearing = google.maps.geometry.spherical.computeHeading(
            centerPoint,
            points[i]
          );
        }

        points = points.sort((a, b) => a.bearing - b.bearing);
        return points;
      } catch (error) {
        console.log(error);
      }
    },
    getTheCategorys: async function() {
      let currentLanguage = localStorage.getItem("lang");
      try {
        const resp = await api.getAllCategorys(currentLanguage);
        let option = {};
        for (let index = 0; index < resp.categories.length; index++) {
          option = {
            label: resp.categories[index].name,
            value: resp.categories[index].id
          };
          this.selectOptions.push(option);
        }
      } catch (error) {}
    }
  },
  computed: {
    userTable: function() {
      return this.$refs.userTable;
    },
    table_columns: function() {
      return this.columns;
    },
    table_headings: function() {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach(column => {
          headings[column] = this.$t(`interactiveMap.table.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filters: function() {
      return this.table_columns.filter(column => column !== "actions");
    },
    table_options: function() {
      return {
        columns: this.table_columns,
        options: {
          columnsDropdown: true,
          headings: this.table_headings,
          sortable: [],
          perPage: 10,
          perPageValues: [10, 25, 50, 100, 200],
          resizableColumns: false,
          columnsClasses: {
            actions: "actions-column"
          },
          texts: {
            filterBy: "{column}",
            columns: this.$t("users.manage.table.column_toggler")
          },
          hiddenColumns: [],
          requestAdapter: function(data) {
            const queries = {};
            queries.page = data.page - 1;
            queries.limit = data.limit;
            queries.query = data.query;

            return queries;
          },
          requestFunction: async function() {
            this.$store.commit("global/SET_LOADING", true);
            try {
              const resp = await api.getAllPoints();
              for (let index = 0; index < resp.points.results.length; index++) {
                resp.points.results[index].mainCoordinates =
                  resp.points.results[index].latMain +
                  "," +
                  resp.points.results[index].longMain;
              }
              this.points = resp.points.results;
              return resp;
            } catch (error) {
            } finally {
              this.$store.commit("global/SET_LOADING", false);
            }
          },
          responseAdapter: function(response) {
            //Sacando las coordenadas del arreglo para la tabla
            let newPoints = this.points;
            let coordinates = "";
            for (let index = 0; index < newPoints.length; index++) {
              coordinates = "";
              for (
                let index2 = 0;
                index2 < newPoints[index].coordinates.length;
                index2++
              ) {
                coordinates +=
                  newPoints[index].coordinates[index2].lat +
                  ", " +
                  newPoints[index].coordinates[index2].long +
                  ", ";
              }
              if (!coordinates.includes("null,")) {
                coordinates = coordinates.substring(0, coordinates.length - 2);
                newPoints[index].coordinates2 = newPoints[index].coordinates;
                newPoints[index].coordinates = coordinates;
              } else {
                newPoints[index].coordinates2 = [];
                newPoints[index].coordinates = "";
              }
            }

            return {
              data: this.points,
              count: this.points.length
            };
          }
        }
      };
    }
  }
};
</script>

<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
.interactiveMap .modal-container {
  max-width: 70vw !important;
  width: 70vw !important;
  max-height: none !important;
}
.interactiveMap .modal-container label {
  @extend %audi-b;
}
.interactiveMap .modal-container footer,
.interactiveMap .modal-container header {
  display: none !important;
}
.interactiveMap .modal-container .scrollable {
  height: 250px;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
.right-controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.right-controls span {
  margin-right: 3rem;
}
.right-controls span:hover {
  text-decoration: underline;
  cursor: pointer;
}
.interactiveMap .modal-container .body-modal {
  width: 100%;
  display: flex;
}
.interactiveMap .pull-right {
  float: none !important;
}
.interactiveMap .modal-container .body-modal .left {
  width: 50%;
  margin-right: auto;
}
.interactiveMap .modal-container .body-modal .right {
  width: 50%;
  margin-left: auto;
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
}

.interactiveMap .modal-container .puntos .inputs-puntos {
  width: 100%;
  display: flex;
}
.interactiveMap .modal-container .puntos .inputs-puntos input {
  width: 55% !important;
}

.interactiveMap .modal-container .scrollable ::-webkit-scrollbar-track {
  width: 10px !important;
}
.headers {
  display: flex;
}
.item-right {
  display: flex;
  margin-left: auto;
  align-items: center;
}
.item-right h4 {
  font-weight: bold;
  color: #000;
}
.btn-publish {
  background-color: #000 !important;
  color: #ffffff !important;
  border-radius: 0px !important;
  padding: 0.5rem !important;
  margin-left: 1rem;
}
.btn-publish:hover {
  background-color: #000;
  color: #ffffff !important;
}
.VueTables .dropdown {
  margin: 1rem 0;
}
.VueTables__columns-dropdown > button {
  @extend %audi;
  color: $black !important;
  background-color: transparent !important;
  border: 1px solid $black !important;
  border-radius: 0 !important;
  padding: 5px 10px !important;
}
.VueTables .dropdown .dropdown-menu {
  padding: 1rem;
  a {
    color: $black;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  a > input {
    margin-right: 0.5rem;
  }
}
#VueTables_th--coordinates {
  width: 240px !important;
}
.VueTables__table.table {
  min-width: 100%;
  width: max-content;
}
.VueTables__table .actions-column {
  position: sticky;
  right: 0;
  text-align: center;
  &:after {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: #f2f2f2;
    top: 0;
    right: 0;
    border-collapse: collapse;
  }
}

.VueTables__table .actions-column > * {
  position: relative;
  z-index: 1;
}
.table-striped tbody tr:nth-of-type(odd) > .actions-column {
  &:after {
    background-color: #e6e6e6;
  }
}
.VueTables__table .id-column {
  max-width: 100px;
}
[class$="filter-wrapper"] {
  min-width: 80px;
  max-width: fit-content;
}
.actions {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.actions > * {
  cursor: pointer;
}
.actions > .edit-btn {
  color: $black;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

  &:hover {
    color: $black;
  }
}
.v-select {
  width: 100%;
}
.vs__dropdown-toggle {
  color: $bg_1;
  border: none;
  border-bottom: 1px solid $wg_1;
  border-radius: 0;
}
#select-search-input {
  width: 0%;
  border: none;
}
.vs__dropdown-option:hover {
  background-color: $wg_3;
  color: $black;
}
.vs__dropdown-option--selected {
  background-color: $b_2;
  color: $white;
}
.vs__dropdown-option--highlight {
  background-color: $wg_3;
  color: $black;
}
.vs__actions {
  cursor: pointer;
}
.vs__selected-options {
  display: flex;
  flex-basis: 100%;
  flex-grow: 1;
  flex-wrap: wrap;
  padding: 0 2px;
  position: relative;
}
</style>
